import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DesktopService {

  constructor(private _http: HttpClient) {
    DesktopService.client = _http;
  }

  static client: HttpClient;

  static getStatus() {
    return DesktopService.client.get<any>(environment.remoteApi + '/info/status');
  }

  getStatus() {
    return DesktopService.client.get<any>(environment.remoteApi + '/info/status');
  }

  getPlayerInfo() {
    return this._http.get<any>(environment.remoteApi + '/info/status');
  }

  getTechnicalInfo() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json'
      })
    };
    return this._http.get<any>(environment.remoteApi + '/info/technical', httpOptions);
  }

  logOut() {
    return this._http.post<any>(environment.remoteApi + '/shutdown', null);
  }

}
